import moment from 'moment';
/**
 * Comparator function for sorting certifications in desc order based on their start date.
 * Cert A is before Cert B: 1
 * Cert A is after Cert B: -1
 * Cert A and Cert B have same start date: 0
 * @param certA
 * @param certB
 * @returns number
 */

export const compareCertsByStartDateDescOrder = (certA, certB) => {
  if (!certA && !certB) {
    return 0;
  }

  if (!certA) return -1;
  if (!certB) return 1;
  const sd1 = certA.startDate;
  const sd2 = certB.startDate;
  if (moment(sd1).isSame(moment(sd2))) return 0;
  if (moment(sd1).isBefore(moment(sd2))) return 1;
  return -1;
};